import { render, staticRenderFns } from "./MoleculeNotFound.vue?vue&type=template&id=c0056cac&"
import script from "./MoleculeNotFound.vue?vue&type=script&lang=js&"
export * from "./MoleculeNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports